import {useMutation} from "@tanstack/react-query";
import {deleteDoc, doc} from "firebase/firestore";
import type {ZodType} from "zod/v4";

import {BaseCollectionConfig} from "~/api/BaseCollectionConfig";
import {firestore} from "~/firebase/firebase";

type DeleteMutationArgs<CollectionArgs extends NonNullable<unknown>> = {
  key: CollectionArgs;
};

export const deletionHookFactory = <
  T extends ZodType,
  CollectionArgs extends NonNullable<unknown>,
>(
  config: BaseCollectionConfig<T, CollectionArgs>,
) => {
  return () => {
    return useMutation<
      void,
      Error,
      DeleteMutationArgs<CollectionArgs & {id?: string}>
    >({
      mutationFn: async ({key}) => {
        // This function actually performs the deletion
        try {
          const documentRef = doc(firestore, ...config.getDocumentPath(key));
          await deleteDoc(documentRef);
        } catch (err) {
          console.error("Error deleting document: ", err);
          throw err;
        }
      },
    });
  };
};
